import styled from "@emotion/styled";
import type { CSSObject } from "@emotion/react";
import { kfSpin } from "@/lib/emotionTw";

export type SpinnerProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
};

type SpinnerSize = "sm" | "md" | "lg";

/* Exact compiled output of the pre-migration Tailwind utilities. */

const spinnerSizeStyles: Record<SpinnerSize, CSSObject> = {
  sm: { width: "1rem", height: "1rem" },
  md: { width: "1.25rem", height: "1.25rem" },
  lg: { width: "1.75rem", height: "1.75rem" }
};

const SpinnerRoot = styled("span", {
  label: "AgenticSpinner-root",
  shouldForwardProp: (propName) => propName !== "ownerState"
})<{ ownerState: { size: SpinnerSize } }>(({ ownerState }) => [
  {
    display: "inline-block",
    ...kfSpin,
    animation: "bfrs-bfrs-spin .8s linear infinite",
    borderRadius: "var(--bfrs-radius-pill)",
    borderWidth: "2px",
    borderColor: "currentColor",
    borderTopColor: "transparent"
  },
  spinnerSizeStyles[ownerState.size]
]);

export function Spinner({ size = "md", className, label = "Loading" }: SpinnerProps) {
  return <SpinnerRoot role="status" aria-label={label} ownerState={{ size }} className={className} />;
}
